import { useEffect, useState } from 'react';
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";
import MomSysCostAnalysisGrid from "./MomSysCostAnalysisGrid";

function MomSysCostAnalysis ( props ) {

    const [height, setHeight] = useState(0);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);


    }, []);

    return(

        <div style={{ height: height }} >

            <ReflexContainer orientation="vertical">

                <ReflexElement flex={0.5}>

                <MomSysCostAnalysisGrid
                    id="MomSysVwCostAnalysisFirst"
                />
                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                <ReflexElement flex={0.5}>

                <MomSysCostAnalysisGrid
                    id="MomSysVwCostAnalysisSecond"
                />

                </ReflexElement>

            </ReflexContainer>
        </div>
    ) 

}

export default MomSysCostAnalysis;